angular.module('nv.features.not-found').controller('NotFoundCtrl', function($stateParams) {
  this.missingUrl = $stateParams.missingUrl;
});
